import AddIcon from "@mui/icons-material/Add";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import TuneIcon from "@mui/icons-material/Tune";
import { Container, Grid, Typography } from "@mui/material";
import { uniq } from "lodash";
import { useEffect, useMemo, useState } from "react";
import { flushSync } from "react-dom";
import { useDispatch, useSelector } from "react-redux";
import CustomButton from "../../../components/CustomButton";
import CustomCheckbox from "../../../components/CustomCheckbox";
import CustomModal from "../../../components/CustomModal/CustomModal";
import Table from "../../../components/CustomTable";
import CustomTextField from "../../../components/CustomTextField";
import { default as Select } from "../../../components/Select/Select";
import SplitButton from "../../../components/SplitButtion";
import {
  clearServicesList,
  getDiagnosticTemplatesWoLoader,
  getServicesByFilter,
  updateBulkPriceForService,
  updateServiceStatusByIds,
} from "../../../redux/reducers/clinicSlice";
import { AppColors } from "../../../util/AppColors";
import { w20h20BlueIcon } from "../../../util/CommonIconStyle";
import {
  isActiveRecord,
} from "../../../util/activeStatus";
import { rolesToCreateInventory } from "../../../util/arrayList";
import {
  discountTypes,
  incDecList,
  ServiceTypes,
  yesNoValueList,
} from "../../../util/dropList";
import ServiceCreateUpdate from "../../CommonScreens/Service/ServiceCreateUpdate";

const tableHeaders = [
  "checkbox",
  "serviceName",
  "category",
  "serStatus",
  "subCategory",
  "sacCode",
  "sellingPrice",
];
const initSearch = {
  name: "",
  category: "",
  subCategory: "",
  type: null,
  sortOrder: "asc",
};
const initFilter = {
  visible: false,
  added: false,
  selectedList: [],
  values: {},
};
const filterByList = [
  "Variant ID",
  "Variant Name",
  "SAC Code",
  "Price Range",
  "Tax Applicability",
  "Taxes",
];
const splitRows = ["Price Range", "Taxes"];

const initBulkPrices = {
  type: "Increase",
  valueType: "Price",
  value: "",
  valueErr: "",
};
const defObj = {
  services: [],
  stocks: [],
  clinic: {},
  dataSharing: {},
  serviceCategories: [],
};

const toSubCategoryList = (subCategories) => {
  const list = Array.isArray(subCategories) ? subCategories : [];
  return list
    .filter((sc) => sc?.name && isActiveRecord(sc))
    .map((sc) => ({
      name: sc.name,
      value: sc.name,
      id: sc.id,
    }));
};

const getFieldName = (name, type) => {
  if (name === "Price Range") {
    if (type === "start") {
      return "Min Price";
    } else {
      return "Max Price";
    }
  }
  if (name === "Taxes") {
    if (type === "start") {
      return "Min Tax %";
    } else {
      return "Max Tax %";
    }
  }
};

const Service = () => {
  const dispatch = useDispatch();
  const [selectedService, setSelectedService] = useState(null);
  const [modVisible, setModVisible] = useState(false);
  const [tableServices, setTableServices] = useState([]);
  const [searchValues, setSearchValues] = useState(initSearch);
  const [searchValue, setSearchValue] = useState("");
  const [page, setPage] = useState(1);
  const [bulkPriceModVsble, setBulkPriceModVsble] = useState(false);
  const [bulkPriceValues, setBulkPriceValues] = useState(initBulkPrices);
  const [filterValues, setFilterValues] = useState(initFilter);
  const { servicesList } = useSelector((state) => state?.clinic);
  const rowsPerPage = 10;
  const user = localStorage.getItem("user");
  const profile = JSON.parse(user);
  const role = localStorage.getItem("role");
  const mandateDataRaw = sessionStorage.getItem("mandateData");
  const { services, stocks, clinic, dataSharing, serviceCategories } =
    useMemo(() => {
      if (!mandateDataRaw) return defObj;
      try {
        const reqData = JSON.parse(mandateDataRaw);
        const categories = Array.isArray(reqData?.categories)
          ? reqData.categories
          : [];
        return {
          services: Array.isArray(reqData?.services) ? reqData?.services : [],
          stocks: Array.isArray(reqData?.stocks) ? reqData?.stocks : [],
          clinic: reqData?.clinic ?? {},
          dataSharing: reqData?.dataSharing ?? {},
          serviceCategories: categories
            .filter((cat) => cat?.type === "services" && cat?.name && isActiveRecord(cat))
            .map((cat) => ({
              name: cat.name,
              value: cat.name,
              id: cat.id,
              categoryType: cat.categoryType ?? null,
              subCategories: Array.isArray(cat.subCategories)
                ? cat.subCategories
                : [],
            })),
        };
      } catch {
        return defObj;
      }
    }, [mandateDataRaw]);

  const actionOptions = useMemo(() => {
    const opts = [];
    if (rolesToCreateInventory.includes(profile?.role || role)) {
      opts.push("Create");
    }
    opts.push(
      ...(tableServices?.find((li) => li?.active === "Y" && li?.selected)
        ? ["Disable"]
        : ["Enable"]),
      "Bulk Price Update",
    );
    return opts;
  }, [profile?.role, role, tableServices]);

  useEffect(() => {
    // Reset filter values to initial state when component mounts
    setFilterValues({ ...initFilter, selectedList: [], values: {} });
  }, []);

  useEffect(() => {
    dispatch(clearServicesList());

    const timeoutId = setTimeout(() => {
      void (async () => {
        await onServiceApiCall(1);
      })();
    }, 300);

    return () => clearTimeout(timeoutId);
  }, [
    searchValues?.name,
    searchValues?.category,
    searchValues?.subCategory,
    searchValues?.type,
    searchValues?.sortOrder,
  ]);

  useEffect(() => {
    getServiceTableData();
  }, [servicesList?.data]);

  const getInventoryDataAccess = () => {
    return dataSharing?.serviceData ?? false;
  };

  const getFilterObj = (currentPage = 1, reset = false) => {
    setPage(currentPage);
    const reqObj = {
      page: currentPage,
      itemSize: rowsPerPage,
      inventryData: getInventoryDataAccess(),
      sortOrder: searchValues?.sortOrder ?? "asc",
    };
    if (reset) return reqObj;
    if (searchValues?.name?.length > 0)
      reqObj.procedureName = searchValues?.name;
    if (searchValues?.category?.length > 0)
      reqObj.category = searchValues?.category;
    if (searchValues?.subCategory?.length > 0)
      reqObj.subCategory = searchValues?.subCategory;
    if (searchValues?.type) reqObj.type = searchValues?.type;

    if (
      filterValues?.selectedList?.includes("Variant ID") &&
      filterValues?.values?.["Variant ID"]?.length > 0
    )
      reqObj.variantNumber = filterValues?.values?.["Variant ID"];
    if (
      filterValues?.selectedList?.includes("Variant Name") &&
      filterValues?.values?.["Variant Name"]?.length > 0
    )
      reqObj.variantName = filterValues?.values?.["Variant Name"];
    if (
      filterValues?.selectedList?.includes("SAC Code") &&
      filterValues?.values?.["SAC Code"]?.length > 0
    )
      reqObj.sacCode = filterValues?.values?.["SAC Code"];
    if (filterValues?.selectedList?.includes("Price Range")) {
      reqObj.minPrice = Number(filterValues?.values?.["Min Price"] ?? 0);
      reqObj.maxPrice = Number(filterValues?.values?.["Max Price"] ?? 0);
    }
    if (filterValues?.selectedList?.includes("Taxes")) {
      reqObj.minTax = Number(filterValues?.values?.["Min Tax %"] ?? 0);
      reqObj.maxTax = Number(filterValues?.values?.["Max Tax %"] ?? 0);
    }
    if (
      filterValues?.selectedList?.includes("Tax Applicability") &&
      filterValues?.values?.["Tax Applicability"]?.length > 0
    ) {
      reqObj.taxApplicability = filterValues?.values?.["Tax Applicability"];
    }
    return reqObj;
  };

  const onServiceApiCall = (currentPage = 1, reset = false) => {
    return dispatch(getServicesByFilter(getFilterObj(currentPage, reset)));
  };

  const handleChangeCheckBox = (value, ind) => {
    const reqList = tableServices?.map((ser, i) => {
      if (i === ind) {
        return { ...ser, selected: value };
      }
      return ser;
    });
    setTableServices(reqList);
  };

  const getSuggestionList = (typ = "hsnSacCode") => {
    if (typ === "hsnSacCode") {
      const reqList = services?.map((ser) => ser?.hsnSacCode ?? "") ?? [];
      const uniqList = uniq(reqList ?? []);
      return uniqList ?? [];
    }
    const reqList = services?.flatMap((ser) => {
      return ser?.serviceVariants
        ?.filter((vr) => (vr?.createdBy ? vr?.createdBy === clinic?.id : true))
        ?.map((variant) =>
          typ === "variantName"
            ? ((variant?.variantName ?? "")?.toString() ?? "")
            : ((variant?.variantNumber ?? "")?.toString() ?? ""),
        );
    });
    const uniqList = uniq(reqList ?? []);
    return uniqList ?? [];
  };

  const getServiceTableData = () => {
    const reqList = servicesList?.data?.map((ser, i) => {
      return {
        ...ser,
        checkbox: (
          <CustomCheckbox
            checked={ser?.selected}
            onChange={() => handleChangeCheckBox(!ser?.selected, i)}
          />
        ),
        serviceName: (
          <div
            className="cursor blue-color underline font-bold fs14"
            onClick={() => handleEditModal(ser)}
          >
            {ser?.serviceName}
          </div>
        ),
        serStatus: (
          <div style={{ width: 80 }}>
            {ser?.active === "Y" ? (
              <Typography className="green4 grn-bck status-card fs12 font-medium">
                Active
              </Typography>
            ) : (
              <Typography className="red11 red-back status-card fs12 font-medium">
                Inactive
              </Typography>
            )}
          </div>
        ),
        sellingPrice: ser?.servicePrice,
        description: ser?.description,
        category: ser?.category,
        subCategory: ser?.subCategory,
        hsnSacCode: ser?.hsnSacCode,
        selected: false,
      };
    });
    setTableServices(reqList);
  };

  const getSupplierTable = () => {
    return tableServices?.map((ser, i) => {
      const clinicVariants = ser?.serviceVariants?.filter((vr) =>
        vr?.createdBy ? vr?.createdBy === clinic?.id : true,
      );
      return {
        checkbox: (
          <CustomCheckbox
            checked={ser?.selected}
            onChange={() => handleChangeCheckBox(!ser?.selected, i)}
          />
        ),
        serviceName: (
          <div className="cursor" onClick={() => handleEditModal(ser)}>
            {ser?.serviceName}
          </div>
        ),
        serStatus: (
          <div style={{ width: 80 }}>
            {ser?.active === "Y" ? (
              <Typography className="green4 grn-bck status-card fs12 font-medium">
                Active
              </Typography>
            ) : (
              <Typography className="red11 red-back status-card fs12 font-medium">
                Inactive
              </Typography>
            )}
          </div>
        ),
        sellingPrice: clinicVariants?.[0]?.servicePrice ?? 0,
        description: ser?.description,
        category: ser?.category,
        subCategory: ser?.subCategory,
        sacCode: ser?.hsnSacCode ?? ser?.sacCode,
        selected: ser?.selected,
      };
    });
  };

  const getDiagnosticTemplates = () => {
    dispatch(getDiagnosticTemplatesWoLoader());
  };

  const handleOpen = () => {
    setModVisible(true);
    getDiagnosticTemplates();
  };

  const handleClose = (typ) => {
    setModVisible(false);
    setSelectedService(null);
    if (typ === "apiSuccess") onServiceApiCall(1);
  };

  const handleChangePage = (e, selectedPage) => {
    onServiceApiCall(selectedPage);
    // setPage(selectedPage);
    setTableServices([]);
    // dispatch(
    //   getServices(
    //     `?page=${selectedPage}&itemSize=${rowsPerPage}&search=${searchValue}`
    //   )
    // );
  };

  const handleSearch = (e) => {
    setSearchValue(e.target.value);
    setPage(1);
    setTableServices([]);
  };

  const onSearchChange = (e) => {
    const { name, value } = e?.target;
    const field = name?.trim()?.replace(/,$/, "");
    const next = {
      ...searchValues,
      [field]: value,
    };
    if (field === "type") {
      next.category = "";
      next.subCategory = "";
    }
    if (field === "category") {
      next.subCategory = "";
    }
    setSearchValues(next);
  };

  const onToggleSortOrder = () => {
    setSearchValues({
      ...searchValues,
      sortOrder: searchValues?.sortOrder === "asc" ? "desc" : "asc",
    });
  };

  const handleEditModal = async (serv) => {
    setSelectedService(serv);
    setModVisible(true);
  };

  const handleAction = (value) => {
    if (value === "Create") handleOpen();
    if (value === "Disable" || value === "Enable") {
      if (!tableServices?.find((li) => li?.selected)) return;
      const ids = tableServices
        ?.filter((li) => li?.selected)
        ?.map((li) => li?.serviceId);
      dispatch(
        updateServiceStatusByIds({
          ids,
          active:
            tableServices?.find((li) => li?.selected)?.active === "Y"
              ? false
              : true,
        }),
      ).then((res) => {
        if (res?.payload) {
          onServiceApiCall(page);
          // dispatch(
          //   getServices(
          //     `?page=${page}&itemSize=${rowsPerPage}&search=${searchValue}`
          //   )
          // );
        }
      });
    }
    if (value === "Bulk Price Update") setBulkPriceModVsble(true);
  };

  const getServiceCategories = () => {
    const list = Array.isArray(serviceCategories) ? serviceCategories : [];
    if (!list.length) return [];
    const selectedType =
      typeof searchValues?.type === "object"
        ? searchValues?.type?.value
        : searchValues?.type;
    if (!selectedType) return list;
    return list.filter((cat) => cat?.categoryType === selectedType);
  };

  const getSubCategoriesByCategory = (value) => {
    const selected =
      typeof value === "object" ? (value?.value ?? value?.name) : value;
    if (!selected) return [];
    const match = (
      Array.isArray(serviceCategories) ? serviceCategories : []
    ).find((cat) => cat?.value === selected || cat?.name === selected);
    return toSubCategoryList(match?.subCategories);
  };

  const onReset = () => {
    flushSync(() => {
      setSearchValues(initSearch);
    });
    flushSync(() => {
      setFilterValues({
        ...initFilter,
        selectedList: [],
        values: {},
      });
    });
    onServiceApiCall(1, true);
  };

  const onFilterChange = (name, value) => {
    const reqObj = { ...filterValues, [name]: value };
    setFilterValues(reqObj);
  };

  const onFilterReset = () => {
    const reqObj = { ...initFilter, visible: true };
    setFilterValues(reqObj);
  };

  const onApplyFilter = () => {
    onServiceApiCall();
    const reqObj = { ...filterValues, visible: false };
    setFilterValues(reqObj);
  };

  const onCloseFilter = () => {
    const reqObj = { ...filterValues, visible: false };
    setFilterValues(reqObj);
    // if (filterValues?.selectedList?.length === 0) return;
    // onServiceApiCall(1);
  };

  const onFilterAdd = (value) => {
    const reqObj = { ...filterValues, added: value };
    setFilterValues(reqObj);
  };

  const onSelectFilter = (name) => {
    const reqObj = { ...filterValues };
    let reqList = filterValues?.selectedList;
    if (reqList?.includes(name)) {
      reqList = reqList?.filter((item) => item !== name);
    } else {
      reqList.push(name);
    }
    reqObj.selectedList = reqList;
    setFilterValues(reqObj);
  };

  const onFilterValuesChange = (e) => {
    const { name, value } = e?.target;
    const reqValue = {
      ...filterValues?.values,
      [name?.trim()?.replace(/,$/, "")]: value,
    };
    const reqObj = { ...filterValues, values: reqValue };
    setFilterValues(reqObj);
  };

  const onCloseBulkPriceMod = () => {
    setBulkPriceModVsble(false);
    setBulkPriceValues(initBulkPrices);
  };

  const onChangeBulkPriceValue = (e) => {
    const { name, value } = e?.target;
    const reqObj = { ...bulkPriceValues, [name]: value };
    if (name === "value") {
      reqObj.valueErr = value?.length > 0 ? "" : "This field is required";
    }
    setBulkPriceValues(reqObj);
  };

  const updateBulkPrice = () => {
    if (!bulkPriceValues?.value || bulkPriceValues?.value?.length === 0) {
      return setBulkPriceValues({
        ...bulkPriceValues,
        valueErr: "This field is required",
      });
    }
    const data = {
      priceType: bulkPriceValues?.valueType?.toLowerCase(),
      type: bulkPriceValues?.type?.toLowerCase(),
      priceValue: Math.abs(Number(bulkPriceValues?.value)),
    };
    dispatch(updateBulkPriceForService(data)).then((res) => {
      if (res?.payload) {
        onCloseBulkPriceMod();
        onServiceApiCall(1);
      }
    });
  };

  const getBatchList = (stockId = null) => {
    if (!stockId) return [];
    const reqStock = stocks?.find((stc) => stc?.stockId === stockId);
    if (!reqStock) return [];
    const filteredBatches = reqStock?.stockBatch?.map((btch) => ({
      name: btch?.batchNo,
      value: btch?.batchNo,
      batchId: btch?.batchId,
      salesUom: btch?.salesUom,
      unitSellingPrice: btch?.unitSellingPrice,
      purchaseUom: btch?.purchaseUom,
      packageUom: btch?.packageUom,
      dosage: btch?.dosage ?? "",
      dosageType: btch?.dosageType ?? null,
    }));
    return filteredBatches;
  };

  return (
    <Container maxWidth="xl">
      <div className="back-white pv10">
        <div className="flex-row-ali-cen flex-center">
          <div className="w15Per">
            <CustomTextField
              placeholder="Procedure Name"
              fullWidth
              name="name"
              backgroundColor={AppColors.lightBlue2}
              value={searchValues?.name}
              handleChange={onSearchChange}
              label="Procedure Name"
            />
          </div>
          <div className="w15Per ml15">
            <Select
              list={getServiceCategories()}
              value={searchValues?.category}
              name="category"
              handleChange={onSearchChange}
              label="Category"
              select
              backgroundColor={AppColors.lightBlue2}
            />
          </div>
          <div className="w15Per ml15">
            <Select
              list={getSubCategoriesByCategory(searchValues?.category)}
              value={searchValues?.subCategory}
              name="subCategory"
              handleChange={onSearchChange}
              label="Subcategory"
              select
              backgroundColor={AppColors.lightBlue2}
            />
          </div>
          <div className="w15Per ml15">
            <Select
              list={ServiceTypes}
              value={searchValues?.type}
              handleChange={onSearchChange}
              name="type"
              select
              label="Type"
              backgroundColor={AppColors.lightBlue2}
            />
          </div>
          <div
            className="flex-row-ali-cen ml15 cursor"
            onClick={onToggleSortOrder}
          >
            {searchValues?.sortOrder === "asc" ? (
              <ArrowUpwardIcon sx={w20h20BlueIcon} />
            ) : (
              <ArrowDownwardIcon sx={w20h20BlueIcon} />
            )}
            <Typography className="font-medium fs12 blue-color ml10">
              {searchValues?.sortOrder === "asc" ? "A-Z" : "Z-A"}
            </Typography>
          </div>
          <div
            className="flex-row-ali-cen ml15 filter cursor"
            onClick={() => onFilterChange("visible", true)}
          >
            <TuneIcon sx={{ color: AppColors.appPrimary }} />
            <Typography className="font-medium fs12 blue-color ml10">
              {filterValues?.selectedList?.length > 0
                ? `${filterValues?.selectedList?.length} `
                : ""}
              Filter
            </Typography>
          </div>
          <div className="ml15">
            <CustomButton text="Reset" onClick={onReset} smallBtn redBtn />
          </div>
          {/* <div className="ml20">
            <CustomButton text="Create" smallBtn onClick={handleOpen} />
          </div> */}
          <div className="ml5">
            <SplitButton list={actionOptions} handleClickItem={handleAction} />
          </div>
        </div>
        <Typography className="font-medium fs12 gray28 ph20 mt10">
          Number of Services: {servicesList?.totalRecords}
        </Typography>
        <div className="mtMin10">
          <Table
            columns={tableHeaders}
            datas={getSupplierTable()}
            page={page}
            rowsPerPage={rowsPerPage}
            totalRecords={servicesList?.totalRecords}
            handleChangePage={handleChangePage}
            grey
            product={true}
            maxHeight="70vh"
          />
        </div>

        <CustomModal
          open={bulkPriceModVsble}
          onClose={onCloseBulkPriceMod}
          header="Bulk Price Update"
          rightModal
          modalWidth={30}
        >
          <Grid container spacing={2} className="ph20">
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Select
                list={incDecList}
                value={bulkPriceValues?.type}
                handleChange={onChangeBulkPriceValue}
                name="type"
                label="Type"
                select
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Select
                list={discountTypes}
                value={bulkPriceValues?.valueType}
                handleChange={onChangeBulkPriceValue}
                name="valueType"
                label="Value Type"
                select
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <CustomTextField
                placeholder="Value"
                fullWidth
                name="value"
                label="Value"
                handleChange={onChangeBulkPriceValue}
                value={bulkPriceValues?.value}
                helperText={bulkPriceValues?.valueErr}
                error={!!bulkPriceValues?.valueErr}
                type="number"
              />
            </Grid>
            <div className="flex1-end mt20">
              <div>
                <CustomButton
                  text="Update"
                  smallBtn
                  onClick={updateBulkPrice}
                />
              </div>
            </div>
          </Grid>
        </CustomModal>
        {modVisible ? (
          <ServiceCreateUpdate
            modVsble={modVisible}
            onCloseMod={handleClose}
            selectedService={selectedService ?? null}
          />
        ) : null}

        <CustomModal
          open={filterValues?.visible}
          onClose={onCloseFilter}
          header="Filter"
          rightModal
          modalWidth={30}
        >
          <div className="scroll-80vh ph20">
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Typography className="gray38 fs12 txt-regular">
                  Filter by:
                </Typography>
                {!filterValues?.added ? (
                  filterByList?.map((li, i) => (
                    <div className="flex-row-ali-cen" key={`${i}_li`}>
                      <div>
                        <CustomCheckbox
                          checked={filterValues?.selectedList?.includes(li)}
                          onChange={() => onSelectFilter(li)}
                        />
                      </div>
                      <Typography className="txt-regular fs14 black mb5 mlMin15">
                        {li}
                      </Typography>
                    </div>
                  ))
                ) : (
                  <div>
                    <div
                      className="flex-row-ali-cen gray-back4 ph10 pv10 br10 width-fit-con mt10 cursor"
                      onClick={() => onFilterAdd(false)}
                    >
                      <AddIcon
                        sx={{ color: AppColors.appPrimary, fontSize: 15 }}
                      />
                      <Typography className="font-medium fs12 blue-color ml5">
                        Add Filter
                      </Typography>
                    </div>
                    <div>
                      {filterValues?.selectedList?.map((li) => (
                        <div className="mt20">
                          {splitRows?.includes(li) ? (
                            <div className="flex-row-between-align-center">
                              <div className="w45Per">
                                <CustomTextField
                                  placeholder={getFieldName(li, "start")}
                                  fullWidth
                                  name={getFieldName(li, "start")}
                                  label={getFieldName(li, "start")}
                                  handleChange={onFilterValuesChange}
                                  value={
                                    filterValues?.values?.[
                                      getFieldName(li, "start")
                                    ] ?? ""
                                  }
                                  type="number"
                                />
                              </div>
                              <div className="w45Per">
                                <CustomTextField
                                  placeholder={getFieldName(li, "end")}
                                  fullWidth
                                  name={getFieldName(li, "end")}
                                  label={getFieldName(li, "end")}
                                  handleChange={onFilterValuesChange}
                                  value={
                                    filterValues?.values?.[
                                      getFieldName(li, "end")
                                    ] ?? ""
                                  }
                                  type="number"
                                />
                              </div>
                            </div>
                          ) : li === "Tax Applicability" ? (
                            <Select
                              list={yesNoValueList}
                              value={filterValues?.values?.[li] ?? ""}
                              name={li}
                              handleChange={onFilterValuesChange}
                              label={li}
                              select
                              // backgroundColor={AppColors.lightBlue2}
                            />
                          ) : (
                            <CustomTextField
                              placeholder={li}
                              fullWidth
                              name={li}
                              handleChange={onFilterValuesChange}
                              value={filterValues?.values?.[li] ?? ""}
                              label={li}
                              suggetions
                              options={getSuggestionList(
                                li === "SAC Code"
                                  ? "hsnSacCode"
                                  : li === "Variant Name"
                                    ? "variantName"
                                    : "variantNumber",
                              )}
                            />
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                )}
                {!filterValues?.added ? (
                  <div className="flex1-end mt15">
                    <div>
                      <CustomButton
                        text="Add"
                        smallBtn
                        onClick={() => onFilterAdd(true)}
                      />
                    </div>
                  </div>
                ) : (
                  <div className="flex-row-center mt15">
                    <div>
                      <CustomButton
                        text="Reset All"
                        smallBtn
                        onClick={onFilterReset}
                        tabSelectdBtn
                      />
                    </div>
                    <div className="ml20">
                      <CustomButton
                        text="Apply Filters"
                        smallBtn
                        onClick={onApplyFilter}
                      />
                    </div>
                  </div>
                )}
              </Grid>
            </Grid>
          </div>
        </CustomModal>
      </div>
    </Container>
  );
};

export default Service;
